import type { Project, Subproject } from "@org-avp/avp-avengers-project-service-api";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const projectSliceName = "project";

export interface ProjectState {
  currentSubproject?: Subproject;
  currentProject?: Project;
}

const initialState: ProjectState = {};
const projectSlice = createSlice({
  name: projectSliceName,
  initialState,
  reducers: {
    setCurrentProject(state: ProjectState, action: PayloadAction<ProjectState>) {
      return action.payload;
    },
  },
});

export interface ProjectRootState {
  [projectSliceName]: ProjectState;
}

export const selectProjectState = (state: ProjectRootState) => state[projectSliceName];
export const selectCurrentSubproject = (state: ProjectRootState) => {
  return selectProjectState(state).currentSubproject;
};
export const selectCurrentProject = (state: ProjectRootState) => {
  return selectProjectState(state).currentProject;
};

export const { setCurrentProject } = projectSlice.actions;
export const projectReducer = projectSlice.reducer;
